/**
 * Hooks
 */
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import useToken from "../../../hooks/useToken";
import useCachedData from "../../../hooks/useCachedData";

/**
 * Utils
 */
import { fetchStaffHoursCategories } from "../../../utils/api";

/**
 * MUI Components
 */
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";

const StaffHourCategorySelectControl = ({ value, handleChange }) => {
    const { t } = useTranslation();
    const { token } = useToken();
    const [localValue, setLocalValue] = useState(value);

    const abortController = new AbortController();
    const fetcher = () => fetchStaffHoursCategories(token, abortController.signal);

    const { data, loading, error } = useCachedData(
        "staff-hours-categories", // Cache key
        fetcher,
        { useCache: true, forceRefresh: false, cacheExpiration: 30000 } // 30 seconds cache expiration
    );

    const handleLocalChange = (event) => {
        const newValue = event.target.value;
        setLocalValue(newValue);
        handleChange(event);
    };

    useEffect(() => {
        return () => abortController.abort(); // Clean up on unmount
    }, []);

    // Only set localValue from value on the first render
    useEffect(() => {
        setLocalValue(value);
        handleChange({ target: { name: 'selectStaffHourCategory', value } });
        // console.debug('WorkActionAreaControl local:', localValue, 'initial:', value);
    }, [value]);

    if (loading) return <p>{t('Loading')}...</p>;
    if (error) return <p>Error: {error}</p>;

    return (
        <FormControl fullWidth>
            <InputLabel id="select-staff-hours-category-label">{t('Hours category')}</InputLabel>
            <Select
                labelId="select-staff-hours-category-label"
                id="select-staff-hours-category"
                name="selectStaffHourCategory"
                value={localValue}
                onChange={handleLocalChange}
                label={t('Hours category')}
                required
            >
                {data.map((item) => (
                    <MenuItem key={item.id} value={item.id}>
                        {item.name}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
}

export default StaffHourCategorySelectControl;